import { BROADCAST_SET_ATTENDEE_CAMERA_STATUS } from 'actions/Types';
import updateProgramByCameraSource from 'actions/Broadcast/program/updateProgramByCameraSource';
import { getProgramLayers } from 'utils/broadcastSourceHelper';

/**
 * This action should _NOT_ be called directly by UI interaction. This is called when the meeting SDK
 * notifies us that an attendee's Camera status has changed. For setting camera status based on a UI
 * interaction, please use setDesiredAttendeeCameraStatus.
 */
export default (attendeeId, isCameraOn) => {
  return (dispatch, getState) => {
    const { program, attendeeCameraStatus } = getState();

    const layers = getProgramLayers(program);

    const currentAttendeeCameraStatus = attendeeCameraStatus[attendeeId];
    // Checking the current status so we don't update if the value is the same.
    if (currentAttendeeCameraStatus === isCameraOn) {
      return;
    }
    const action = {
      type: BROADCAST_SET_ATTENDEE_CAMERA_STATUS,
      payload: { attendeeId, isCameraOn }
    };

    dispatch(action);

    const [layerSource] = layers?.filter(
      layer => layer?.source?.value === attendeeId
    );
    // see if source is in program layer
    if (!!layerSource) {
      const attendeeIdMap = {};
      attendeeIdMap[attendeeId] = attendeeId;
      dispatch(updateProgramByCameraSource(attendeeIdMap));
    }
  };
};
